import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';

export const Favorites = ({ highlighted, label, ...rest }) => (
  <li
    className={classNames('dropdown__item', {
      'dropdown__item--highlighted': highlighted,
    })}
    {...rest}>
    <div className="dropdown__item__link">
      <Isvg className="dropdown__item__icon" src={DESIGN_SYSTEM_ICONS.heartFilled} />
      <div className="dropdown__item__content">
        <span className="dropdown__item__label dropdown__item__label--no-wrap">{label}</span>
      </div>
    </div>
  </li>
);

Favorites.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  label: PropTypes.object.isRequired,
};
